import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { SigninComponent } from "../pages/signin/signin.component";
import { PageNotFoundComponent } from "../pages/404/404.component";
import { ManufacturerComponent } from "../pages/manufacturer-layout/manufacturer/manufacturer.component";
import { AdminComponent } from "src/pages/admin-layout/admin/admin.component";
import { DistributorComponent } from "src/pages/distributor-layout/distributor/distributor.component";
import { AdminLayoutComponent } from "src/pages/admin-layout/admin-layout.component";
import { ManufacturerLayoutComponent } from "../pages/manufacturer-layout/manufacturer-layout.component";
import { DistributorLayoutComponent } from "../pages/distributor-layout/distributor-layout.component";
import { ChangePasswordComponent } from "../components/change-password/change-password.component";
import { ForgotPasswordComponent } from "../components/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "../components/reset-password/reset-password.component";

import { AuthGuard } from "./auth.guard";

const routes: Routes = [
	{
		path: "manufacturer",
		redirectTo: "brand-owner",
		pathMatch: "full"
	},
	{
		path: "brand-owner",
		component: ManufacturerLayoutComponent,
		children: [
			{
				path: "locations",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "locations",
				},
			},
			{
				path: "products",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "products",
				},
			},
			{
				path: "incidents",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "incidents",
				},
			},
			{
				path: "live-tracking",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "live-tracking",
				},
			},
			{
				path: "expiry-report",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "expiry-report",
				},
			},
			{
				path: "batch-recall",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "batch-recall",
				},
			},
			{
				path: "recall-report",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "recall-report",
				},
			},
			{
				path: "manage-chain",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "manage-chain",
				},
			},
			{
				path: "manage-location",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "manage-location",
				},
			},
			{
				path: "manage-user",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "manage-user",
				},
			},
			{
				path: "manage-medicine",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "manage-medicine",
				},
			},
			{
				path: "manage-batch",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "manage-batch",
				},
			},
			{
				path: "manage-package",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "manage-package",
				},
			},
			{
				path: "manage-label",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "manage-label",
				},
			},
			{
				path: "manage-device",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "manage-device",
				},
			},
			{
				path: "manage-asset",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "manage-asset",
				},
			},
			{
				path: "manage-billing",
				component: ManufacturerComponent,
				data: {
					type: "manage-billing",
				},
			},
			{
				path: "print-label",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "print-label",
				},
			},
			{
				path: "delete-batch",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "delete-batch",
				},
			},
			{
				path: "import",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "import",
				},
			},
			{
				path: "epics-new-import",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "epics-new-import",
				},
			},
			{
				path: "manage-profile",
				component: ManufacturerComponent,
				canActivate: [AuthGuard],
				data: {
					type: "manage-profile",
				},
			},
			{
				path: "",
				component: ManufacturerComponent,
				data: {
					type: "dashboard",
				},
			}
		]
	},
	{
		path: "admin",
		component: AdminLayoutComponent,
		children: [
			{
				path: "manage-batch",
				component: AdminComponent,
				data: {
					type: "manage-batch",
				},
			},
			{
				path: "incidents",
				component: AdminComponent,
				data: {
					type: "incidents",
				},
			},
			{
				path: "expiry-report",
				component: AdminComponent,
				data: {
					type: "expiry-report",
				},
			},
			{
				path: "recall-report",
				component: AdminComponent,
				data: {
					type: "recall-report",
				},
			},
			{
				path: "batch-recall",
				component: AdminComponent,
				data: {
					type: "batch-recall",
				},
			},
			{
				path: "products",
				component: AdminComponent,
				data: {
					type: "products",
				},
			},
			{
				path: "manage-segments",
				component: AdminComponent,
				data: {
					type: "manage-segments",
				},
			},
			{
				path: "locations",
				component: AdminComponent,
				data: {
					type: "locations",
				},
			},

			{
				path: "manage-role",
				component: AdminComponent,
				data: {
					type: "manage-role",
				},
			},
			{
				path: "manage-manufacturer",
				component: AdminComponent,
				data: {
					type: "manage-manufacturer",
				},
			},
			{
				path: "manage-notifications",
				component: AdminComponent,
				data: {
					type: "manage-notifications",
				},
			},
			{
				path: "manage-chain",
				component: AdminComponent,
				data: {
					type: "manage-chain",
				},
			},
			{
				path: "manage-user",
				component: AdminComponent,
				data: {
					type: "manage-user",
				},
			},
			{
				path: "manage-label",
				component: AdminComponent,
				data: {
					type: "manage-label",
				},
			},
			{
				path: "manage-location",
				component: AdminComponent,
				data: {
					type: "manage-location",
				},
			},
			{
				path: "manage-medicine",
				component: AdminComponent,
				data: {
					type: "manage-medicine",
				},
			},
			{
				path: "manage-profile",
				component: AdminComponent,
				data: {
					type: "manage-profile",
				},
			},
			{
				path: "",
				component: AdminComponent,
				data: {
					type: "dashboard",
				},
			}
		],
	},
	{
		path: "distributor",
		component: DistributorLayoutComponent,
		children: [
			{
				path: "incidents",
				component: DistributorComponent,
				data: {
					type: "incidents",
				},
			},
			{
				path: "items-received",
				component: DistributorComponent,
				data: {
					type: "items-received",
				},
			},
			{
				path: "items-sent",
				component: DistributorComponent,
				data: {
					type: "items-sent",
				},
			},
			{
				path: "manage-profile",
				component: DistributorComponent,
				data: {
					type: "manage-profile",
				},
			},
			{
				path: "",
				component: DistributorComponent,
				data: {
					type: "dashboard",
				},
			}
		]
	},
	{
		path: "forgot-password",
		component: ForgotPasswordComponent,
	},
	{
		path: "reset-password",
		component: ResetPasswordComponent,
	},
	{
		path: "change-password",
		component: ChangePasswordComponent,
	},
	{ path: "signin", component: SigninComponent },
	{ path: "", component: SigninComponent },
	{ path: "**", component: PageNotFoundComponent },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
